import React, {FC} from "react"

import Slider from "@irati/ui/src/Slider"
import Spacing from "@irati/ui/src/Spacing"
import {DESKTOP, PHONE_LANDSCAPE, TABLET} from "@irati/ui/src/global/media"
import authentication from "@irati/auth"
import {ReportType} from "@irati/types"
import rewardsReportService from "@irati/wallet/services/rewardsReporting"
import ReportingCard from "./ReportingCard"

const sliderSettings = {
  responsive: [
    {breakpoint: PHONE_LANDSCAPE - 1, settings: {slidesToShow: 1.3, slidesToScroll: 1, nextArrow: null, prevArrow: null}},
    {breakpoint: TABLET - 1, settings: {slidesToShow: 1.2, slidesToScroll: 1}},
    {breakpoint: DESKTOP - 1, settings: {slidesToShow: 2, slidesToScroll: 2}}
  ]
}

const ReportingSection: FC = () => {

  const handleCSVDownload = (reportType: ReportType) => {
    rewardsReportService.getRewardsReportUrl(authentication.business().uuid, reportType)
      .then(({reportFileUrl}) => {
        const fileName = "reward-log.csv"
        const link = document.createElement("a")
        link.setAttribute("href", reportFileUrl)
        link.setAttribute("download", fileName)
        link.style.visibility = "hidden"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
  }

  return (
    <Slider slidesToShow={3} settings={sliderSettings}>
      <ReportingCard
        reportId={ReportType.FlexipointsTransactions}
        title="platform.wallet.reward.reports.cardOne.title"
        body="platform.wallet.reward.reports.cardOne.body"
        onClick={() => handleCSVDownload(ReportType.FlexipointsTransactions)} />
      <Spacing paddingRight={1.5} paddingLeft={1.5}>
        <ReportingCard
          reportId={ReportType.PointsBalance}
          title="platform.wallet.reward.reports.cardTwo.title"
          body="platform.wallet.reward.reports.cardTwo.body"
          onClick={() => handleCSVDownload(ReportType.PointsBalance)} />
      </Spacing>
      <ReportingCard
        reportId={ReportType.PointsTransactions}
        title="platform.wallet.reward.reports.cardThree.title"
        body="platform.wallet.reward.reports.cardThree.body"
        onClick={() => handleCSVDownload(ReportType.PointsTransactions)} />
    </Slider>
  )
}

export default ReportingSection
